export default class DateTimeValidation {
    constructor (dto) {
        this.mask = dto ? dto.Mask : ''
    }
}
